const toNumber = (value) => {
  if (value === null || value === undefined || value === "") {
    return null;
  }
  const numberValue = Number(value);
  return Number.isNaN(numberValue) ? null : numberValue;
};

const pickNumber = (source, keys) => {
  if (!source || typeof source !== "object" || !Array.isArray(keys)) {
    return null;
  }
  for (const key of keys) {
    if (!key) continue;
    const value = toNumber(source[key]);
    if (value !== null) {
      return value;
    }
  }
  return null;
};

export const normalizeQuota = (payload = {}, config = {}) => {
  const used = pickNumber(payload, config.usedKeys) ?? null;
  const total = pickNumber(payload, config.totalKeys) ?? null;
  const remaining = pickNumber(payload, config.remainingKeys) ?? null;
  return {
    used,
    total,
    remaining,
    raw: payload
  };
};

export const isQuotaExceeded = (quota) => {
  if (!quota) return false;
  const { used, total, remaining } = quota;
  if (total !== null && total > 0 && used !== null) {
    return used >= total;
  }
  if (remaining !== null) {
    return remaining <= 0;
  }
  return false;
};
